import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const InvitationAcceptPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./InvitationAcceptPage')).InvitationAcceptPage,
  }))
);
